module.exports = __webpack_public_path__ + "img/me.7e4dbf8e.jpg";